import React from "react";

export const GOALS = [
  { id: "weight_loss", label: "Weight Loss", desc: "Calorie-controlled, high protein, lots of greens" },
  { id: "muscle_gain", label: "Muscle Gain", desc: "Calorie surplus, high protein, big plates" },
  { id: "fat_loss", label: "Fat Loss", desc: "Moderate deficit, protein-heavy, low-glycemic" },
];

export const WORKOUT_CATEGORIES_META = ["strength", "cardio", "recovery"];

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric" }); }
  catch { return iso; }
};
